/**
 * Razvan Garage – cautare dupa poza.
 *
 * Pune un buton cu aparat foto in caseta de cautare. Clientul face sau alege o poza cu eticheta, cutia sau
 * piesa; poza e micsorata in browser si trimisa programului de pe api.razvangarage.ro, care intoarce codurile
 * citite din ea. Codurile sunt apoi cautate in magazin cu aceleasi reguli ca la cautarea dupa cod
 * (rg-cautare-cod.js), iar produsele gasite apar intr-o fereastra.
 *
 * Butonul apare numai cat timp programul de pe server spune ca functia e pornita.
 */
(() => {
  if (window.rgCautarePoza) return;

  const SERVER = 'https://api.razvangarage.ro/poza.php';
  const LATURA_MAX = 2000;          // pixeli pe latura mare a pozei trimise
  const MARIME_MAX = 1800000;       // octeti; peste, poza se comprima mai tare
  const STARE = 'rg-poza-stare';
  const PRODUSE_MAX = 6;

  const TEXT = {
    buton: 'Caută după poză',
    titlu: 'Caută după poză',
    inchide: 'Închide',
    indemn: 'Fă o poză de aproape cu eticheta, cutia sau codul de pe piesă.',
    faPoza: 'Fă o poză',
    galerie: 'Alege din galerie',
    citesc: 'Citesc codul din poză…',
    caut: (cod) => `Am citit codul „${cod}”. Caut în magazin…`,
    gasit: (cod) => `Am citit codul „${cod}”:`,
    faraCod: (tip, fraza) => `Nu am văzut un cod în poză. Pare a fi ${tip}. Produse pentru „${fraza}”:`,
    codNegasit: (cod, fraza) => `Am citit codul „${cod}”, dar nu l-am găsit în magazin. Produse pentru „${fraza}”:`,
    codLipsa: (cod) => `Am citit codul „${cod}”, dar nu l-am găsit în magazin.`,
    nimic: 'Nu am putut citi un cod din poză. Încearcă o poză mai clară, de aproape, cu eticheta sau cu codul de pe piesă.',
    siCoduri: 'Am citit și:',
    toate: 'Vezi toate rezultatele',
    alta: 'Altă poză',
    whatsapp: 'Trimite-ne poza pe WhatsApp',
    nota: 'Poza e folosită doar ca să citim codul piesei și nu se păstrează.',
    erori: {
      limita: 'Ai făcut mai multe căutări după poză într-un timp scurt. Încearcă din nou peste câteva minute.',
      limita_zi: 'Căutarea după poză a fost foarte folosită azi. Încearcă mâine sau scrie-ne pe WhatsApp.',
      poza: 'Nu am putut deschide poza. Încearcă altă poză.',
      altceva: 'Căutarea după poză nu merge acum. Încearcă din nou puțin mai târziu.'
    }
  };

  const ICON = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M4 8.5A1.5 1.5 0 0 1 5.5 7h2.2l1.2-1.9a1 1 0 0 1 .85-.47h4.5a1 1 0 0 1 .85.47L16.3 7h2.2A1.5 1.5 0 0 1 20 8.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 17.5z"/><circle cx="12" cy="13" r="3.4"/></svg>';

  // Tema are html { font-size: 10px }, de aceea marimile sunt in pixeli.
  const CSS = `
.rg-poza-btn{position:absolute;top:calc(50% - 22px);right:0;min-height:44px;padding:10px 9px;border:0;background:none;color:currentColor;line-height:0;cursor:pointer}
.rg-poza-btn svg{width:24px;height:24px}
form.search--rg-poza .search__speech{right:42px;inset-inline-end:42px;padding:10px}
form.search--rg-poza .search__input{padding-inline-end:92px!important}
form.search--rg-poza .search__input.search__input--dirty{padding-inline-end:136px!important}
form.search--rg-poza .search__reset{right:86px}
.speech-search--failed form.search--rg-poza .search__input{padding-inline-end:50px!important}
.speech-search--failed form.search--rg-poza .search__input.search__input--dirty{padding-inline-end:92px!important}
.speech-search--failed form.search--rg-poza .search__reset{right:44px}
.rg-poza{position:fixed;inset:0;z-index:9999;width:min(520px,calc(100vw - 24px));height:fit-content;max-height:calc(100dvh - 24px);margin:auto;padding:0;border:0;border-radius:14px;background:#fff;color:#1c1f26;box-shadow:0 20px 60px rgba(0,0,0,.35);font-size:15px;line-height:1.4;text-align:left}
.rg-poza:not([open]){display:none}
.rg-poza::backdrop{background:rgba(10,12,16,.6)}
.rg-poza__cap{display:flex;align-items:center;justify-content:space-between;padding:14px 16px;border-bottom:1px solid #e6e8ec;font-size:16px;font-weight:700}
.rg-poza__inchide{width:36px;height:36px;margin:-6px -8px -6px 0;border:0;border-radius:50%;background:none;color:inherit;font-size:24px;line-height:1;cursor:pointer}
.rg-poza__corp{padding:16px;overflow:auto}
.rg-poza__sus{display:flex;gap:14px;align-items:center}
.rg-poza__poza{width:84px;height:84px;flex:0 0 84px;border-radius:10px;background:#f1f2f4;object-fit:cover}
.rg-poza__stare{font-weight:600}
.rg-poza__stare--lucru::after{content:"";display:inline-block;width:14px;height:14px;margin-left:8px;border:2px solid #c9ccd3;border-top-color:#ff580d;border-radius:50%;vertical-align:-2px;animation:rg-poza-rot .8s linear infinite}
@keyframes rg-poza-rot{to{transform:rotate(360deg)}}
.rg-poza__observatie{margin:6px 0 0;color:#5b616e;font-size:14px}
.rg-poza__produse{margin:14px 0 0;padding:0;list-style:none}
.rg-poza__produse li{border-top:1px solid #eef0f3}
.rg-poza__produs{display:flex;gap:12px;align-items:center;padding:10px 0;color:inherit;text-decoration:none}
.rg-poza__produs img,.rg-poza__faraimg{width:56px;height:56px;flex:0 0 56px;border-radius:8px;background:#f1f2f4;object-fit:contain}
.rg-poza__nume{display:block;font-weight:600}
.rg-poza__detalii{display:block;margin-top:2px;color:#5b616e;font-size:13px}
.rg-poza__pret{color:#1c1f26;font-weight:700}
.rg-poza__coduri{margin:12px 0 0;font-size:14px}
.rg-poza__coduri a{display:inline-block;margin:4px 6px 0 0;padding:4px 10px;border:1px solid #d5d8de;border-radius:999px;color:inherit;text-decoration:none}
.rg-poza__actiuni{display:flex;flex-wrap:wrap;gap:10px;margin-top:16px}
.rg-poza__actiune{display:inline-flex;align-items:center;justify-content:center;min-height:44px;padding:10px 16px;border:1px solid #1c1f26;border-radius:10px;background:#fff;color:#1c1f26;font-size:15px;font-weight:600;text-decoration:none;cursor:pointer}
.rg-poza__actiune--plin{border-color:#ff580d;background:#ff580d;color:#fff}
.rg-poza__nota{margin:14px 0 0;color:#7a808c;font-size:12px}
@media (max-width:600px){.rg-poza{margin-bottom:12px}.rg-poza__actiune{flex:1 1 100%}}
`;

  let fereastra;
  let alegere;
  let stilPus = false;
  let cautare = 0;      // numarul cautarii in curs; raspunsurile unei cautari mai vechi se ignora

  const element = (nume, clasa, text) => {
    const el = document.createElement(nume);
    if (clasa) el.className = clasa;
    if (text) el.textContent = text;
    return el;
  };

  function puneStil() {
    if (stilPus) return;
    stilPus = true;
    const stil = element('style');
    stil.textContent = CSS;
    document.head.append(stil);
  }

  // Browserele vechi nu au <dialog>; acolo fereastra se deschide ca un element obisnuit.
  function deschide() {
    if (!fereastra.showModal) fereastra.setAttribute('open', '');
    else if (!fereastra.open) fereastra.showModal();
  }

  function inchide() {
    if (fereastra.close) {
      fereastra.close();
    } else {
      fereastra.removeAttribute('open');
      cautare += 1;
    }
  }

  /**
   * Intreaba serverul daca functia e pornita; raspunsul se tine minte cateva ore.
   * @returns {Promise<boolean>}
   */
  async function ePornita() {
    try {
      const salvat = JSON.parse(localStorage.getItem(STARE) || 'null');
      if (salvat && salvat.pana > Date.now()) return salvat.activ === true;
    } catch (error) { /* fara localStorage se intreaba de fiecare data */ }

    let activ = false;
    try {
      const raspuns = await fetch(SERVER);
      activ = raspuns.ok && (await raspuns.json()).activ === true;
    } catch (error) { /* serverul nu raspunde: butonul nu apare */ }

    try {
      localStorage.setItem(STARE, JSON.stringify({ activ, pana: Date.now() + (activ ? 6 : 0.5) * 3600000 }));
    } catch (error) { /* la fel */ }
    return activ;
  }

  function adaugaButoane() {
    document.querySelectorAll('form.search search-form').forEach((caseta) => {
      if (caseta.querySelector('.rg-poza-btn')) return;

      const buton = element('button', 'rg-poza-btn focus-inset');
      buton.type = 'button';
      buton.title = TEXT.buton;
      buton.setAttribute('aria-label', TEXT.buton);
      buton.innerHTML = ICON;
      buton.addEventListener('click', alegePoza);
      caseta.append(buton);
      caseta.closest('form').classList.add('search--rg-poza');
    });
  }

  /**
   * Deschide alegerea pozei.
   * @param {boolean} camera - Deschide direct camera telefonului, nu galeria.
   */
  function deschideAlegerea(camera) {
    if (!alegere) {
      alegere = element('input');
      alegere.type = 'file';
      alegere.accept = 'image/*';
      alegere.hidden = true;
      alegere.addEventListener('change', () => {
        const fisier = alegere.files[0];
        alegere.value = '';
        if (fisier) cauta(fisier);
      });
      document.body.append(alegere);
    }
    if (camera) alegere.setAttribute('capture', 'environment');
    else alegere.removeAttribute('capture');
    alegere.click();
  }

  // Pe telefon, selectorul de poze al sistemului deschide galeria si nu mai ofera camera, de aceea
  // clientul alege intai: camera (ceruta anume) sau galeria. Pe calculator se deschide direct alegerea fisierului.
  function alegePoza() {
    if (!window.matchMedia('(pointer: coarse)').matches) {
      deschideAlegerea(false);
      return;
    }
    if (!fereastra) construiesteFereastra();
    cautare += 1;
    parte('poza').hidden = true;
    stare(TEXT.indemn);
    actiune(TEXT.faPoza, true).addEventListener('click', () => deschideAlegerea(true));
    actiune(TEXT.galerie, false).addEventListener('click', () => deschideAlegerea(false));
    deschide();
  }

  /**
   * Micsoreaza poza si o rescrie ca JPEG (pozele de telefon au cativa MB).
   * @param {Blob} fisier - Poza aleasa.
   * @returns {Promise<Blob>}
   */
  async function micsoreaza(fisier) {
    let sursa;
    try {
      sursa = await createImageBitmap(fisier);
    } catch (error) {
      sursa = await new Promise((gata, esec) => {
        const img = new Image();
        img.onload = () => gata(img);
        img.onerror = () => esec(new Error('poza'));
        img.src = URL.createObjectURL(fisier);
      });
    }

    const latime = sursa.naturalWidth || sursa.width;
    const inaltime = sursa.naturalHeight || sursa.height;
    const scara = Math.min(1, LATURA_MAX / Math.max(latime, inaltime));
    const panza = document.createElement('canvas');
    panza.width = Math.round(latime * scara);
    panza.height = Math.round(inaltime * scara);
    panza.getContext('2d').drawImage(sursa, 0, 0, panza.width, panza.height);

    const jpeg = (calitate) => new Promise((gata) => { panza.toBlob(gata, 'image/jpeg', calitate); });
    let poza = await jpeg(0.86);
    if (poza && poza.size > MARIME_MAX) poza = await jpeg(0.7);
    if (!poza) throw new Error('poza');
    return poza;
  }

  /**
   * Produsele din magazin pentru o cautare (lista scurta, ca la sugestii).
   * @param {string} interogare - Textul cautat.
   * @returns {Promise<Array<object>>}
   */
  async function sugestii(interogare) {
    const radacina = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const parametri = new URLSearchParams({ q: interogare, 'resources[type]': 'product', 'resources[limit]': PRODUSE_MAX });
    try {
      const raspuns = await fetch(`${radacina}search/suggest.json?${parametri}`);
      if (!raspuns.ok) return [];
      return (await raspuns.json()).resources.results.products || [];
    } catch (error) {
      return [];
    }
  }

  /**
   * Produsele care au codul dat, in oricare dintre scrierile lui.
   * @param {string} cod - Codul citit din poza.
   * @returns {Promise<Array<object>>}
   */
  async function produseDupaCod(cod) {
    const scrieri = (window.rgCautareCod && window.rgCautareCod.interogari(cod)) || [];
    const liste = await Promise.all((scrieri.length ? scrieri : [`"${cod.replace(/"/g, '')}"`]).map(sugestii));
    const vazute = new Set();
    return liste.flat().filter((produs) => {
      if (vazute.has(produs.handle)) return false;
      vazute.add(produs.handle);
      return true;
    }).slice(0, PRODUSE_MAX);
  }

  /**
   * Spune serverului daca s-a gasit in magazin ce s-a citit din poza. Se noteaza doar codul si felul
   * piesei; din cele negasite se vede ce coduri lipsesc din anunturi.
   * @param {boolean} gasit - S-au gasit produse dupa cod.
   * @param {string} cod - Codul gasit sau codurile citite si negasite.
   * @param {string} tip - Felul piesei spus de server.
   */
  function raporteaza(gasit, cod, tip) {
    const parametri = new URLSearchParams({ rezultat: gasit ? '1' : '0', cod: cod || '', tip: tip || '' });
    fetch(`${SERVER}?${parametri}`, { keepalive: true }).catch(() => {});
  }

  function construiesteFereastra() {
    puneStil();

    fereastra = element('dialog', 'rg-poza');
    fereastra.setAttribute('aria-label', TEXT.titlu);
    const cap = element('div', 'rg-poza__cap');
    const iks = element('button', 'rg-poza__inchide', '×');
    iks.type = 'button';
    iks.setAttribute('aria-label', TEXT.inchide);
    iks.addEventListener('click', inchide);
    cap.append(element('span', '', TEXT.titlu), iks);

    const corp = element('div', 'rg-poza__corp');
    const sus = element('div', 'rg-poza__sus');
    const text = element('div');
    text.append(element('div', 'rg-poza__stare'), element('p', 'rg-poza__observatie'));
    text.firstChild.setAttribute('role', 'status');
    const poza = element('img', 'rg-poza__poza');
    poza.alt = '';
    sus.append(poza, text);
    corp.append(sus, element('ul', 'rg-poza__produse'), element('div', 'rg-poza__coduri'),
      element('div', 'rg-poza__actiuni'), element('p', 'rg-poza__nota', TEXT.nota));

    fereastra.append(cap, corp);
    fereastra.addEventListener('click', (evt) => { if (evt.target === fereastra) inchide(); });
    fereastra.addEventListener('close', () => { cautare += 1; });
    document.body.append(fereastra);
  }

  const parte = (clasa) => fereastra.querySelector(`.rg-poza__${clasa}`);

  /**
   * Scrie in fereastra starea cautarii si goleste rezultatele dinainte.
   * @param {string} text - Mesajul.
   * @param {boolean} [lucru] - Arata rotita de asteptare.
   */
  function stare(text, lucru) {
    parte('stare').textContent = text;
    parte('stare').classList.toggle('rg-poza__stare--lucru', Boolean(lucru));
    ['observatie', 'produse', 'coduri', 'actiuni'].forEach((clasa) => parte(clasa).replaceChildren());
  }

  const adresaCautare = (text) => {
    const radacina = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${radacina}search?q=${encodeURIComponent(text)}`;
  };

  function actiune(text, plin, adresa) {
    const el = element(adresa ? 'a' : 'button', `rg-poza__actiune${plin ? ' rg-poza__actiune--plin' : ''}`, text);
    if (adresa) el.href = adresa; else el.type = 'button';
    parte('actiuni').append(el);
    return el;
  }

  function actiuniFaraRezultat(cod) {
    actiune(TEXT.alta, true).addEventListener('click', alegePoza);
    const legatura = document.querySelector('a.rg-wa-float[href*="wa.me/"]');
    if (!legatura) return;
    const mesaj = cod ? `Bună ziua! Caut o piesă cu codul ${cod}. Vă trimit și poza.` : 'Bună ziua! Caut o piesă. Vă trimit o poză cu ea.';
    const wa = actiune(TEXT.whatsapp, false, `${legatura.href.split('?')[0]}?text=${encodeURIComponent(mesaj)}`);
    wa.target = '_blank';
    wa.rel = 'noopener';
  }

  function arataProduse(titlu, produse, cautat, alteCoduri) {
    stare(titlu);
    produse.forEach((produs) => {
      const rand = element('a', 'rg-poza__produs');
      rand.href = produs.url;
      const imagine = produs.image ? element('img') : element('span', 'rg-poza__faraimg');
      if (produs.image) {
        imagine.src = `${produs.image}${produs.image.includes('?') ? '&' : '?'}width=112`;
        imagine.alt = '';
        imagine.loading = 'lazy';
      }
      const text = element('span');
      const detalii = element('span', 'rg-poza__detalii', produs.vendor ? `${produs.vendor} · ` : '');
      const pret = Number(produs.price);
      if (pret > 0) detalii.append(element('span', 'rg-poza__pret', `${pret.toFixed(2).replace('.', ',')} lei`));
      text.append(element('span', 'rg-poza__nume', produs.title), detalii);
      rand.append(imagine, text);
      const li = element('li');
      li.append(rand);
      parte('produse').append(li);
    });

    if (alteCoduri.length) {
      parte('coduri').append(element('span', '', `${TEXT.siCoduri} `));
      alteCoduri.forEach((cod) => {
        const legatura = element('a', '', cod);
        legatura.href = adresaCautare(cod);
        parte('coduri').append(legatura);
      });
    }
    actiune(TEXT.toate, true, adresaCautare(cautat));
    actiune(TEXT.alta, false).addEventListener('click', alegePoza);
  }

  /**
   * Arata in fereastra ce a iesit din raspunsul serverului.
   * @param {object} raspuns - Raspunsul programului de pe server.
   * @param {number} [numar] - Cautarea careia ii apartine raspunsul.
   */
  async function arata(raspuns, numar = cautare) {
    if (!raspuns || !raspuns.ok) {
      const motiv = raspuns && raspuns.motiv;
      stare(TEXT.erori[motiv] || TEXT.erori.altceva);
      actiuniFaraRezultat('');
      return;
    }

    const coduri = (raspuns.coduri || []).map((cod) => cod.text);
    for (const cod of coduri) {
      stare(TEXT.caut(cod), true);
      const produse = await produseDupaCod(cod);
      if (numar !== cautare) return;
      if (produse.length) {
        raporteaza(true, cod, raspuns.tip_piesa);
        arataProduse(TEXT.gasit(cod), produse, cod, coduri.filter((alt) => alt !== cod));
        return;
      }
    }
    raporteaza(false, coduri.join(' | '), [raspuns.tip_piesa, raspuns.marca].filter(Boolean).join(' '));

    // Fara cod gasit: produse de acelasi fel; daca marca citita nu e in magazin, doar dupa felul piesei.
    let fraza = [raspuns.tip_piesa, raspuns.marca].filter(Boolean).join(' ');
    let asemanatoare = raspuns.tip_piesa ? await sugestii(fraza) : [];
    if (!asemanatoare.length && raspuns.tip_piesa && raspuns.marca) {
      fraza = raspuns.tip_piesa;
      asemanatoare = await sugestii(fraza);
    }
    if (numar !== cautare) return;
    if (asemanatoare.length) {
      arataProduse(coduri.length ? TEXT.codNegasit(coduri[0], fraza) : TEXT.faraCod(raspuns.tip_piesa, fraza), asemanatoare, fraza, []);
      return;
    }

    stare(coduri.length ? TEXT.codLipsa(coduri[0]) : TEXT.nimic);
    parte('observatie').textContent = raspuns.observatie || '';
    actiuniFaraRezultat(coduri[0] || '');
  }

  /**
   * Cauta dupa poza aleasa: o micsoreaza, o trimite si arata rezultatul.
   * @param {Blob} fisier - Poza aleasa de client.
   */
  async function cauta(fisier) {
    if (!fereastra) construiesteFereastra();
    cautare += 1;
    const numar = cautare;

    const veche = parte('poza').src;
    parte('poza').hidden = false;
    parte('poza').src = URL.createObjectURL(fisier);
    if (veche) URL.revokeObjectURL(veche);
    stare(TEXT.citesc, true);
    deschide();

    let raspuns;
    try {
      const corp = new FormData();
      corp.append('poza', await micsoreaza(fisier), 'poza.jpg');
      raspuns = await (await fetch(SERVER, { method: 'POST', body: corp })).json();
    } catch (error) {
      raspuns = { ok: false, motiv: error && error.message === 'poza' ? 'poza' : 'altceva' };
    }
    if (numar === cautare) await arata(raspuns, numar);
  }

  window.rgCautarePoza = { cauta, arata, adaugaButoane };

  ePornita().then((activ) => {
    if (!activ) return;
    puneStil();
    adaugaButoane();
    document.addEventListener('shopify:section:load', adaugaButoane);
  });
})();
